import {
  BottomSheet,
  BottomSheetIllustrationContent,
  useModalState,
} from "@clipboard-health/ui-components";
import { Box } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { DialogFooter } from "../../../components/DialogFooter";
import { hasLocationStateBooleanKey } from "./utils/hasLocationStateBooleanKey";

export function LateClockOutInstructionsBottomSheet() {
  const modalState = useModalState("open");
  const history = useHistory();
  const location = useLocation();

  const onClose = useCallback(() => {
    if (hasLocationStateBooleanKey(location.state, "justClockedIn")) {
      const { justClockedIn: _justClockedIn, ...restState } = location.state;
      history.replace(location.pathname, restState);
    }
  }, [history, location.pathname, location.state]);

  return (
    <BottomSheet canDismiss modalState={modalState} onClose={onClose}>
      <Box>
        <BottomSheetIllustrationContent
          hasFooter
          illustrationType="clock-warning"
          title="Late stay instructions"
          description="If you need to stay later than your scheduled clock-out time, you must extend your shift before that time, or you will be clocked out."
        />
        <DialogFooter orientation="vertical">
          <Button
            fullWidth={true}
            onClick={() => {
              modalState.closeModal();
              onClose();
            }}
          >
            Ok, got it.
          </Button>
        </DialogFooter>
      </Box>
    </BottomSheet>
  );
}
